import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15734eee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "OkInput__name"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OkInput__required" }, "*", -1))
const _hoisted_3 = { class: "OkInput__wrap" }
const _hoisted_4 = {
  key: 0,
  class: "OkInput__prefix"
}
const _hoisted_5 = ["autocomplete", "placeholder", "type", "min", "value", "disabled"]
const _hoisted_6 = {
  key: 1,
  class: "OkInput__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkInput", {
            'OkInput--invalid': _ctx.isInvalid,
            'OkInput--success': _ctx.isSuccess,
            'OkInput--warning': _ctx.isWarning,
            'OkInput--disabled': _ctx.disabled,
        }])
  }, [
    (Boolean(_ctx.name))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.required)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
                _hoisted_2
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.name), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (Boolean(_ctx.prefix))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.prefix), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        class: "OkInput__control",
        autocomplete: _ctx.autocomplete,
        placeholder: _ctx.placeholder,
        type: _ctx.type,
        min: _ctx.min,
        value: _ctx.value,
        disabled: _ctx.disabled,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitChange && _ctx.emitChange(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitFocus && _ctx.emitFocus(...args)))
      }, null, 40, _hoisted_5), [
        [_directive_maska, _ctx.maska]
      ])
    ]),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ], 2))
}